import { render, staticRenderFns } from "./order-product-issue-row.vue?vue&type=template&id=61f35770&scoped=true"
import script from "./order-product-issue-row.vue?vue&type=script&lang=js"
export * from "./order-product-issue-row.vue?vue&type=script&lang=js"
import style0 from "./order-product-issue-row.vue?vue&type=style&index=0&id=61f35770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f35770",
  null
  
)

export default component.exports